import React, { useState } from "react";
import styled from "styled-components";
import { Layout } from "antd";
import { Button, ProTableOt } from '../ui/ot';

const { Content } = Layout;

const data = [
    { key: "1", name: "張三", date: "2024-08-01", shift: "早班" },
    { key: "2", name: "李四", date: "2024-08-01", shift: "晚班" },
];

const columns = [
    { title: "姓名", dataIndex: "name", key: "name" },
    { title: "日期", dataIndex: "date", key: "date" },
    { title: "班次", dataIndex: "shift", key: "shift" },
];

const ChangeSchedule = () => {
    const [data1, setData1] = useState(data);
    const [data2, setData2] = useState(data);
    const [selectedKeys1, setSelectedKeys1] = useState([]);
    const [selectedKeys2, setSelectedKeys2] = useState([]);

    const handleCheckboxChange1 = (key) => {
        setSelectedKeys1((prev) =>
            prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
        );
    };

    const handleCheckboxChange2 = (key) => {
        setSelectedKeys2((prev) =>
            prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
        );
    };

    const handleExchange = () => {
        const selectedData1 = data1.filter((item) =>
            selectedKeys1.includes(item.key)
        );
        const selectedData2 = data2.filter((item) =>
            selectedKeys2.includes(item.key)
        );

        if (selectedData1.length === 1 && selectedData2.length === 1) {
            const newData1 = data1.map((item) =>
                selectedKeys1.includes(item.key) ? selectedData2[0] : item
            );
            const newData2 = data2.map((item) =>
                selectedKeys2.includes(item.key) ? selectedData1[0] : item
            );

            setData1(newData1);
            setData2(newData2);
            setSelectedKeys1([]);
            setSelectedKeys2([]);
        } else {
            alert("每個表格中只能選擇一條記錄進行交換");
        }
    };

    const handleReset = () => {
        setData1(data);
        setData2(data);
        setSelectedKeys1([]);
        setSelectedKeys2([]);
    };

    return (
        <Layout style={{ padding: "0 24px 24px" }}>
            <StyledContent>
                <Container>
                    <ProTableOt
                        columns={columns}
                        rowKey="key"
                        request={async (params) => {
                            const filteredData = data.filter(
                                (item) =>
                                    item.name.includes(params.keyword || "") ||
                                    item.employeeNumber.includes(params.keyword || "")
                            );
                            const currentPage = params.current || 1;
                            const pageSize = params.pageSize || 10;
                            const startIndex = (currentPage - 1) * pageSize;
                            const paginatedData = filteredData.slice(startIndex, startIndex + pageSize);
                            return {
                                data: paginatedData,
                                success: true,
                                total: filteredData.length,
                            };
                        }}
                        pagination={{ pageSize: 5 }}
                        onDataChange={(newData) => setData1(newData)}
                        rowSelection={{
                            selectedRowKeys: selectedKeys1,
                            onChange: (selectedKeys) =>
                                handleCheckboxChange1(selectedKeys),
                        }}
                    />

                    <ButtonContainer>
                        <Button
                            type="primary"
                            onClick={handleExchange}
                            style={{ marginBottom: 8 }}
                        >
                            交換
                        </Button>
                        <Button onClick={handleReset}>重設</Button>
                    </ButtonContainer>

                    <ProTableOt
                        columns={columns}
                        rowKey="key"
                        request={async (params) => {
                            const filteredData = data.filter(
                                (item) =>
                                    item.name.includes(params.keyword || "") ||
                                    item.employeeNumber.includes(params.keyword || "")
                            );
                            const currentPage = params.current || 1;
                            const pageSize = params.pageSize || 10;
                            const startIndex = (currentPage - 1) * pageSize;
                            const paginatedData = filteredData.slice(startIndex, startIndex + pageSize);
                            return {
                                data: paginatedData,
                                success: true,
                                total: filteredData.length,
                            };
                        }}
                        pagination={{ pageSize: 5 }}
                        onDataChange={(newData) => setData2(newData)}
                        rowSelection={{
                            selectedRowKeys: selectedKeys2,
                            onChange: (selectedKeys) =>
                                handleCheckboxChange2(selectedKeys),
                        }}
                    />
                </Container>
            </StyledContent>
        </Layout>
    );
};


const StyledContent = styled(Content)`
  margin: 20px;
  padding: 24px;
  background: #fff;
  min-height: 280px;
  @media (max-width: 768px) {
    margin: 10px;
    padding: 12px;
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 10%;
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 16px;
  }
`;

export default ChangeSchedule;
